const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.16 21.65V21.65C11.9964 22.8237 10.1003 22.8278 8.93162 21.6592L8.21586 20.9434C7.56398 20.2915 7.23804 19.9656 7.04153 19.627C6.50108 18.6958 6.50108 17.5464 7.04153 16.6152C7.23804 16.2766 7.56398 15.9507 8.21586 15.2988L11.0532 12.4615C11.7082 11.8065 12.0357 11.479 12.3762 11.2819C13.3057 10.744 14.452 10.744 15.3815 11.2819C15.722 11.479 16.0495 11.8065 16.7045 12.4615L17.4142 13.1712C18.5852 14.3422 18.5833 16.2413 17.41 17.41V17.41",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.83 10.35V10.35C20.0003 9.17526 21.9018 9.17344 23.0743 10.3459L23.7813 11.0529C24.4363 11.7079 24.7639 12.0355 24.9609 12.376C25.4988 13.3055 25.4988 14.4517 24.9609 15.3812C24.7639 15.7217 24.4363 16.0493 23.7813 16.7043L20.9474 19.5382C20.2924 20.1932 19.9648 20.5208 19.6243 20.7178C18.6948 21.2557 17.5486 21.2557 16.6191 20.7178C16.2786 20.5208 15.951 20.1932 15.296 19.5382L14.5859 18.8281C13.4151 17.6573 13.417 15.7585 14.59 14.59V14.59",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.33f0aeff6647093491e30eaa19e42d4e.svg";
export { ForwardRef as ReactComponent };